/* Re-usable & accessible drawer menu helper/handler
- Traps focus (pass trap as arg because each menu gets it's own trap)
- Toggles active class of menu & backdrop (aka scrim)
- Toggles body class to lock scroll/prevent scrollbar layout shift
- Sets aria attributes
- Escape key closes menu
*/

import { createFocusTrap } from 'focus-trap';

const bodyLockClass = 'u-drawerMenuOpen';
const bodyLockClassTablet = 'u-drawerMenuOpenTablet';
const menuClass = 'active';

let isScrollbarWidthSet = false;

export function getFocusTrap(element) {
  // clickOutsideDeactivates = click backdrop deactivates
  // Not using escape key deactivates in case this is used for a menu with submenus
  return createFocusTrap(element, {
    clickOutsideDeactivates: true,
  });
}

export function setScrollBarWidth() {
  // Without this, the body will shift when a menu opens
  if (!isScrollbarWidthSet) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    isScrollbarWidthSet = true; // Ensure only set width once
  }
}

export function setBodyScrollLock(isMenuOpen, isTabletOnly = false) {
  const className = isTabletOnly ? bodyLockClassTablet : bodyLockClass;
  // eslint-disable-next-line no-unused-expressions
  isMenuOpen ? document.body.classList.add(className) : document.body.classList.remove(className);
}

export function setBackdropActive(backdrop, isMenuOpen) {
  if (backdrop) {
    // eslint-disable-next-line no-unused-expressions
    isMenuOpen ? backdrop.classList.add(menuClass) : backdrop.classList.remove(menuClass);
  }
}

export function handleMenuOpened(trap, menu, backdrop) {
  try {
    trap.activate();
    menu.classList.add(menuClass);
    setBackdropActive(backdrop, true);
    setBodyScrollLock(true);
    menu.setAttribute('aria-hidden', false);
  } catch (error) {
    error.log(error);
  }
}

export function handleMenuClosed(trap, menu, backdrop) {
  try {
    trap.deactivate();
    menu.classList.remove(menuClass);
    setBackdropActive(backdrop, false);
    setBodyScrollLock(false);
    menu.setAttribute('aria-hidden', true);
  } catch (error) {
    error.log(error);
  }
}

export function addEscapeKeyListener(trap, menu, backdrop) {
  menu.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      handleMenuClosed(trap, menu, backdrop);
    }
  });
}
